import React, { useState } from 'react';
import './Navigation.css';

const Navigation = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  // Prevents the link from navigating when clicked
  const handleDropdownClick = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className="hamburger-icon" onClick={toggleMobileMenu}>
        &#9776;
      </div>
      <nav className={`main-nav ${isMobileMenuOpen ? 'mobile-active' : ''}`}>
        <ul>
          <li><a href="/">Home</a></li>
          <li><a href="/about-us-2/">About</a></li>
          <li className="dropdown">
            <a href="/consulting-services" onClick={handleDropdownClick}>Consulting Services</a>
            <ul className="dropdown-menu">
              <li className="sub-dropdown">
                <a href="/best-sap-consulting-services-usa/" onClick={handleDropdownClick}>SAP Consulting <span>&rsaquo;</span></a>
                <ul className="sub-dropdown-menu">
                  <li><a href="/service/sap-grc-consulting-implementation-services/">SAP GRC</a></li>
                  <li><a href="/service/sap-security-consulting-services/">SAP Security</a></li>
                  <li className="sub-dropdown opens-left">
                    <a href="/service/sap-successfactors-consulting-hr-solutions/" onClick={handleDropdownClick}>SAP Success Factors <span>&rsaquo;</span></a>
                    <ul className="sub-dropdown-menu">
                        <li><a href="/service/employee-central">Employee Central</a></li>
                        <li><a href="/service/recruitment">Recruitment</a></li>
                        {/* UPDATED: Added link to the new page */}
                        <li><a href="/service/onboarding">Onboarding</a></li>
                    </ul>
                  </li>
                  <li><a href="/service/sap-ariba-consulting-and-implementation-services/">SAP Ariba</a></li>
                  <li><a href="/service/best-sap-fico-consultant-services-usa/">SAP FICO</a></li>
                </ul>
              </li>
              <li><a href="/ai-and-ml-consulting-services/">AI/ML</a></li>
              <li><a href="/top-sap-staff-augmentation-services/">Staff Augmentation</a></li>
            </ul>
          </li>
          <li className="dropdown">
             <a href="/service/" onClick={handleDropdownClick}>Industries</a>
             <ul className="dropdown-menu">
                <li><a href="/service/manufacturing/">Manufacturing</a></li>
                <li><a href="/service/banking/">Banking</a></li>
                <li><a href="/service/automotive/">Automotive</a></li>
                <li><a href="/service/sap-consulting-services-for-retail-industry/">Retail</a></li>
             </ul>
          </li>
          <li><a href="/blog/">Our Blog</a></li>
          <li><a href="/contact-us/">Contact us</a></li>
        </ul>
      </nav>
    </>
  );
};

export default Navigation;
